import { render, staticRenderFns } from "./LogisticsCompany.vue?vue&type=template&id=bb1ceec6&scoped=true&"
import script from "./LogisticsCompany.vue?vue&type=script&lang=js&"
export * from "./LogisticsCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb1ceec6",
  null
  
)

export default component.exports